module.exports = __webpack_public_path__ + "img/glm_gbt6187_1_2000.prt.af06299a.jpg";